module.exports = __webpack_public_path__ + "img/image24.822f31ea.png";